import React from 'react';

import { SubmissionList } from './submission-list';
import { SubmissionForm } from './submission-form';
import { formatDateToDDMMYYYY } from '../../../utils/date';
import {
  EventPlaylistChallenge,
  EventPlaylistChallengeSubmissionListItem
} from '../../../types/event';
import { ActivityEventProps } from '../../activity-event-view';

export const getStatusBadge = (status?: string) => {
  switch (status?.toLowerCase()) {
    case 'approved':
      return {
        text: 'Approved',
        style: {
          color: 'white',
          backgroundColor: '#14BF8B'
        }
      };
    case 'pending_review':
      return {
        text: 'Pending review',
        style: {
          color: 'white',
          backgroundColor: '#003A64'
        }
      };
    case 'rejected':
      return {
        text: 'Declined',
        style: {
          color: 'white',
          backgroundColor: '#FF5527'
        }
      };
    default:
      return {
        text: 'Not submitted',
        style: {
          color: 'black',
          backgroundColor: '#D9D9D9'
        }
      };
  }
};

export const formatSubDate = (dateStr?: string) => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return '';
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = String(d.getFullYear()).slice(-2);
  return `${day}/${month}/${year}`;
};

export const WSTActivity: React.FC<ActivityEventProps> = ({
  index,
  eventId,
  locations,
  clientName,
  event: eventActivity
}) => {
  const [submittingChallenge, setSubmittingChallenge] =
    React.useState<EventPlaylistChallenge | null>(null);
  const [submittedSubmission, setSubmittedSubmission] =
    React.useState<EventPlaylistChallengeSubmissionListItem | null>(null);

  const gamelocations = React.useMemo(() => {
    if (!locations) return '';

    return locations.map((l) => `${l.country} ${l.city}`).join(', ');
  }, [locations]);

  return (
    <>
      <div className={'mt-4'}>Activity {(index as number) + 1}</div>
      <div
        className={'card d-flex flex-row flex-wrap'}
        style={{
          gap: '92px',
          padding: '24px',
          marginBottom: '20px'
        }}>
        <div className={'d-flex flex-column'}>
          <span style={{ color: '#A5B7BF' }}>Game name</span>
          <span className={'fw-bold'}>{eventActivity?.game}</span>
        </div>
        <div className={'d-flex flex-column'}>
          <span style={{ color: '#A5B7BF' }}>Event date</span>
          <span className={'fw-bold'}>
            {formatDateToDDMMYYYY(eventActivity?.startDateUtc!)}
          </span>
        </div>
        <div className={'d-flex flex-column'}>
          <span style={{ color: '#A5B7BF' }}>Client</span>
          <span className={'fw-bold'}>{clientName}</span>
        </div>
        <div className={'d-flex flex-column'}>
          <span style={{ color: '#A5B7BF' }}>Location</span>
          <span className={'fw-bold'}>{gamelocations}</span>
        </div>
        <div className={'d-flex flex-column'}>
          <span style={{ color: '#A5B7BF' }}>Pax</span>
          <span className={'fw-bold'}>{eventActivity?.approxPax}</span>
        </div>
      </div>

      {/* submission list */}
      {!submittingChallenge && (
        <SubmissionList
          playlistId={eventActivity?.id}
          notes={eventActivity?.notes ?? ''}
          activityEventId={eventId || eventActivity?.eventId}
          setSubmittingChallenge={setSubmittingChallenge}
          setSubmittedSubmission={setSubmittedSubmission}
        />
      )}

      {/* submission form */}
      {submittingChallenge && (
        <SubmissionForm
          playlistId={eventActivity?.id}
          submittingChallenge={submittingChallenge}
          submittedSubmission={submittedSubmission}
          activityEventId={eventId || eventActivity?.eventId}
          onCancel={() => {
            setSubmittingChallenge(null);
            setSubmittedSubmission(null);
          }}
        />
      )}
    </>
  );
};
